/** Branch release profile. Keep both workflows; production and UAT deliberately differ here only. */
export const APP_EDITION: "production" | "full" = "full";
export const FULL_FEATURES = ["full"].includes(APP_EDITION);

export const ZERO_QCOEF = { finActual: 0, fin: 0, fabPx: 0, fabYld: 0, trimPx: 0, trimYld: 0, add: 0, cmMult: 0, tariff: 0 };
